export default {
  daysPerMonth: 22,
  daysPerYear: 250,
  minSalary: 425,
  maxSalary: 10000,
  startSalary: 3209,
  sliderStep: 25,
  groupSalaries: {
    // Niedriglohn: '(< 2139 €)',
    // Mitte: '(2139 € - 5700 €)',
    // Topverdiener: '',
    // 'Topverdiener +': ''
  },
  colors: ['#acacff', '#00e7e5','#a2e767', '#ffbc3f', '#ff8785'],
  colorDomain: [1700, 2600, 3200, 6000, 1000000],
  swoopyText: 'Mit Ihrem Gehalt bräuchten Sie statt eines Monats ...',
  userItemText: 'Ein Monat entspricht 22 Arbeitstagen'
};